import { Component, ElementRef, OnDestroy } from "@angular/core";
import { DateFilterMenuComponent, PopupCloseEvent, SinglePopupService } from "@progress/kendo-angular-grid";
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { Subscription } from 'rxjs/subscription';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

const closest = (node: any, predicate: any): any => {
    while (node && !predicate(node)) {
        node = node.parentNode;
    }

    return node;
};

@Component({
    selector: 'chassis-datatable-filter-menu-time',
    templateUrl: './time.component.html',
    styleUrls: ['./time.component.scss'],
})
export class TimeComponent extends DateFilterMenuComponent implements OnDestroy {
    public firstOperator = 'eq';
    public firstValue: Date;

    public logicOperator: 'and' | 'or' = 'and';

    public secondOperator = 'eq';
    public secondValue: Date;

    public popupSettings: any = {
        popupClass: 'timepicker-filter'
    };

    protected popupSubscription: Subscription;

    constructor(
        protected element: ElementRef,
        protected localization: LocalizationService,
        protected popupService: SinglePopupService,
    ) {
        super(localization);

        // Handle the service onClose event and prevent the menu from closing when the timepickers are still active.
        this.popupSubscription = popupService.onClose.subscribe((e: PopupCloseEvent) => {
            if (document.activeElement && closest(document.activeElement,
                node => node === this.element.nativeElement || (String(node.className).indexOf('timepicker-filter') >= 0))) {
                e.preventDefault();
            }
        });
    }

    public onValueChange() {
        this.filter = this.removeFilter(this.column.field);

        const filters = [];

        if (this.firstValue && this.firstOperator) {
            this.firstValue = new Date(0, 0, 0, this.firstValue.getHours(), this.firstValue.getMinutes());

            filters.push({
                field: this.column.field,
                operator: this.firstOperator,
                value: this.firstValue
            });
        }

        if (this.secondValue && this.secondOperator) {
            this.secondValue = new Date(0, 0, 0, this.secondValue.getHours(), this.secondValue.getMinutes());

            filters.push({
                field: this.column.field,
                operator: this.secondOperator,
                value: this.secondValue
            });
        }

        const root: CompositeFilterDescriptor = this.filter || {
            logic: this.logicOperator,
            filters: []
        };

        if (filters.length) {
            root.filters.push(...filters);
        }

        this.filterService.filter(root);
    }

    public ngOnDestroy(): void {
        if (this.popupSubscription) {
            this.popupSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/menu/time/time.component.ts